import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
  Button,
  Divider,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { white } from '@styles/colors';
import { medium } from '@styles/fontWeights';
import { FC } from 'react';

type WhyWorkBlockProps = {
  label: string;
  value?: string | null;
  tooltip?: string;
  action: () => void;
};

const WhyWorkBlock: FC<WhyWorkBlockProps> = ({
  label,
  value,
  tooltip,
  action,
}) => {
  return (
    <>
      <Grid
        container
        alignItems="center"
        bgcolor={white}
        borderRadius={8}
        py={2}
      >
        <Grid item xs={12} sm={4}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography
              fontWeight={medium}
              display="flex"
              gap={1}
              alignItems="center"
            >
              {label}:{' '}
              {tooltip && (
                <Tooltip title={tooltip} placement="top" arrow>
                  <HelpOutlineIcon
                    sx={{
                      fontSize: '18px',
                      color: 'grey.400',
                      transition: 'color 0.35s ease',
                      '&:hover': { color: 'grey.900' },
                    }}
                  />
                </Tooltip>
              )}
            </Typography>
          </Stack>
        </Grid>

        <Grid
          item
          xs={12}
          sm={4}
          justifyContent="center"
          display="flex"
          flexDirection="column"
          textAlign="center"
        >
          {value?.blocks?.length ? (
            <Typography fontWeight={medium}>
              {value.blocks.length} Block{value.blocks.length > 1 ? 's' : ''}{' '}
              Added
            </Typography>
          ) : (
            <Typography fontWeight={medium}>No Blocks Added</Typography>
          )}
        </Grid>

        <Grid item xs={12} sm={4} justifyContent="end" display="flex">
          <Button
            color={value ? 'primary' : 'success'}
            id={`edit-button-${label.toLowerCase().replace(/\s+/g, '-')}`}
            variant="contained"
            sx={{
              padding: '4px 15px',
              fontSize: '14px',
            }}
            startIcon={
              value ? (
                <EditOutlinedIcon sx={{ fontSize: '16px' }} />
              ) : (
                <AddOutlinedIcon sx={{ fontSize: '16px' }} />
              )
            }
            onClick={action}
          >
            {value ? 'Edit' : 'Add'}
          </Button>
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: '7px' }} />
    </>
  );
};

export default WhyWorkBlock;
